import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const TheoryTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter members who are in Theory Task Group
  const getTaskGroupMembers = () => {
    if (!teamData.boardMembers || !teamData.honoraryMembers) return [];

    const allMembers = [
      ...teamData.boardMembers,
      ...teamData.honoraryMembers
    ].filter(member =>
      member.taskGroups && member.taskGroups.includes('Theory Task Group')
    );

    // Define the desired order
    const memberOrder = [
      'Matthias Schwab',
      'Peter Sundman',
      'Ferdinand Wolf',
      'Marie-Christine Cabié',
      'Svea Van Der Hoorn',
      'Rytis Pakrosnis',
      'Ingrid Reich',
      'Jonas Wells'
    ];

    // Sort members according to the defined order
    return allMembers.sort((a, b) => {
      const indexA = memberOrder.indexOf(a.name);
      const indexB = memberOrder.indexOf(b.name);

      // If both are in the order list, sort by their position
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      // If only a is in the list, it comes first
      if (indexA !== -1) return -1;
      // If only b is in the list, it comes first
      if (indexB !== -1) return 1;
      // If neither is in the list, maintain original order
      return 0;
    });
  };

  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const activityCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginBottom: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link 
          to="/task-groups" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          📚 Theory Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Collecting, discussing, creating, and publishing solution-focused practice and theory related ideas
        </p>
      </div>

      {/* Mission */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎯</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Mission</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The Theory Task Group (former Practice Definition Task Group) collects, discusses, creates, and publishes 
          solution-focused practice and theory related ideas for the solution-focused community.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          We engage in a co-creative process of shaping theoretical thoughts of solution-focused practice in a creative, 
          joyful and sometimes reiterative systematic way that leads to carefully crafted 'co-knowing' formulations.
        </p>
      </div>

      {/* EBTA Theory Book */}
      <div style={{...sectionStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📖</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#166534', margin: 0}}>Theory of Solution-Focused Practice 2020</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem', alignItems: 'start'}}>
          <div>
            <p style={{color: '#166534', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              <strong>The EBTA Book "Theory of Solution-Focused Practice" 2020 has been published!</strong>
            </p>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              We, the authors, are happy with this co-creative process of shaping the theoretical thoughts of the solution-focused 
              practice in a creative, joyful and sometimes reiterative systematic way that lead to the carefully crafted 
              'co-knowing' formulations in the book.
            </p>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              Also disputes and differences are visible together with the additional reviewer 'co-knowers' views. 
              It has been like a piece of Jazz: constantly changing and developing, with many variations in an open-ended 
              process that provides space for further developments.
            </p>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '2rem'}}>
              <strong>Now we are excited to see where it goes next!</strong>
            </p>
            
            <div style={{
              backgroundColor: '#dcfce7',
              padding: '1.5rem',
              borderRadius: '8px',
              marginBottom: '1.5rem'
            }}>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>Available Translations</h4>
              <ul style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', paddingLeft: '1.5rem', margin: 0}}>
                <li>Dutch (complete translation)</li>
                <li>Italian (complete translation)</li>
                <li>Polish (complete translation)</li>
                <li>Finnish (condensed translation)</li>
                <li>German (earlier version)</li>
                <li>French (earlier version)</li>
              </ul>
            </div>
          </div>
          
          <div style={{textAlign: 'center'}}>
            <div style={{
              backgroundColor: '#ffffff',
              padding: '2rem',
              borderRadius: '12px',
              border: '2px solid #bbf7d0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                width: '150px',
                height: '200px',
                backgroundColor: '#f3f4f6',
                borderRadius: '8px',
                margin: '0 auto 1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '3rem',
                color: '#6b7280',
                backgroundImage: 'url(/images/boek.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}>
              </div>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>
                Order Our Book
              </h4>
              <p style={{color: '#6b7280', fontSize: '0.9rem', marginBottom: '1.5rem'}}>
                Available in print and digital formats
              </p>
              <a 
                href="https://buchshop.bod.de/catalogsearch/result/?q=ebta"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#059669',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#047857';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#059669';
                }}
              >
                Order Book →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Activities */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>⚡</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Activities</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem'}}>
          
          {/* Theory Development */}
          <div style={{...activityCardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#2563eb'}}>🧠</div>
              <h4 style={{color: '#1e40af', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Theory Development</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Collecting and discussing solution-focused practice and theory related ideas through collaborative 
              co-creative processes that shape theoretical understanding.
            </p>
          </div>

          {/* Publications */}
          <div style={{...activityCardStyle, backgroundColor: '#fef3c7', border: '1px solid #fde047'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#d97706'}}>📝</div>
              <h4 style={{color: '#a16207', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Publications</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Creating and publishing theoretical formulations, books, and articles that advance 
              solution-focused understanding and practice within the community.
            </p>
          </div>

          {/* Collaborative Process */}
          <div style={{...activityCardStyle, backgroundColor: '#fdf4ff', border: '1px solid #e9d5ff'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#7c2d12'}}>🎵</div>
              <h4 style={{color: '#7c2d12', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Jazz-like Process</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Engaging in a creative process "like a piece of Jazz: constantly changing and developing, 
              with many variations in an open-ended process that provides space for further developments."
            </p>
          </div>

          {/* Co-knowing */}
          <div style={{...activityCardStyle, backgroundColor: '#fef2f2', border: '1px solid #fecaca'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#dc2626'}}>🤝</div>
              <h4 style={{color: '#dc2626', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Co-knowing</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Developing carefully crafted 'co-knowing' formulations where disputes and differences 
              are visible alongside reviewer perspectives, creating rich theoretical understanding.
            </p>
          </div>
        </div>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Task Group Members</h2>
        </div>
        
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getTaskGroupMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '0.5rem'}}>
                  {member.name}
                </h3>
                {member.role === 'Honorary Board Member' && (
                  <div style={{
                    backgroundColor: '#fef3c7',
                    color: '#a16207',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '12px',
                    fontSize: '0.8rem',
                    fontWeight: '600',
                    display: 'inline-block'
                  }}>
                    Honorary Member
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Contact & Support */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📧</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Get Involved</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '1.5rem', maxWidth: '600px', margin: '0 auto 1.5rem'}}>
          Interested in contributing to solution-focused theory development?
        </p>
        <p style={{fontSize: '1rem', color: '#64748b', marginBottom: '2rem'}}>
          Join our collaborative co-creative process of shaping theoretical understanding.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/research/definition"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📚</span>
            Learn About Our Theory
          </Link>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TheoryTaskGroup;
